import { InviteMemberProvider } from '../context';
import InviteMemberBuilder from '../components/invite/InviteMemberBuilder';

/**
 * Invite members (CT-5610): full-page stepper at `members/invite`. Provider glue only; the
 * builder owns the layout.
 */
function MemberInvitePage() {
  return (
    <InviteMemberProvider>
      <InviteMemberBuilder />
    </InviteMemberProvider>
  );
}

export default MemberInvitePage;
